export default __webpack_public_path__ + "static/media/boop.f1badfea.mp3";